<template>
    <div class="evento">
      <v-form v-model="valid" @submit.prevent="actualizarPersona()">
          <v-container>
              <v-layout row wrap>
                  <v-flex xs12><h2>Persona</h2></v-flex>
                  <v-flex xs12>
                      <v-autocomplete
                          v-model="persona"
                          :items="personas"
                          :loading="isLoading"
                          :search-input.sync="search"
                          item-text="completo"
                          item-value="id"
                          label="Persona"
                          placeholder="Busca a la persona"
                          return-object no-filter
                          autocomplete
                      ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                      <h2>Diagnostico</h2>
                  </v-flex>
                  <v-flex xs12>
                      <v-textarea
                      label="Diagnostico"
                      v-model="diagnostico"
                      hint="Dianostico"
                      ></v-textarea>
                  </v-flex>
                  <v-flex x12 md12>
                      <v-btn color="info" type="submit" block>Guardar</v-btn>
                  </v-flex>
              </v-layout>
          </v-container>
      </v-form>
  </div>
</template>

<script>
import swal from "sweetalert2";
import axios from "axios";
import GlogalJS from '../mixins/GlobalJs';

export default {
  name: 'evento',
  components: {},
  mixins: [GlogalJS],
  data() {
    return {
      valid: false,
      personas: [],
      persona: null,
      isLoading: false,
      search: null,
      diagnostico: null,
      evento: null
    }
  },
  watch: {
    search (val) {
      if (val != null && val.length < 4) return
      if (this.isLoading) return
      this.isLoading = true
      fetch(`${this.server_api}/personas?search=${val}`)
        .then(res => res.json())
        .then(res => {
          this.personas = res
        })
        .catch(err => {
          //console.log(err)
        })
        .finally(() => (this.isLoading = false))
    }
  },
  methods: {
      actualizarPersona() {
        axios.put(`${this.server_api}/personas/${this.persona.id}`, {
            servicio_id: this.persona.servicio_id,
            diagnostico: this.diagnostico
        }).then(response => {
            swal('Great!', 'Actualizado correctamente', 'success');
            this.diagnostico = null;
        }).catch(error => { swal('Oops!', 'No se actualizo', 'error') });
      }
  }
}
</script>

<style scoped>
  .evento{
    width: 100%;
    height: 100%;
  }
</style>